<template>
  <v-card>
    <v-card-title :class="textCenter ? 'justify-center' : ''">Volunteer Experience</v-card-title>

    <ListCard :items='experience' />
  </v-card>
</template>

<script>
import { mdiTwitter, mdiWeb } from '@mdi/js'
import ListCard from '../ListCard'

export default {
  name: 'VolunteerExperience',
  components: {
    ListCard
  },
  data(){
    return {
      experience: [
        {
          src: '/img/workExperience/sehir.png',
          alt: 'student mentor',
          name: 'Student Mentor | Istanbul Sehir University Student Affairs',
          date: '11/2017 - 06/2018',
          summary: 'I was working as a student montor. It was a great opportunity to experience sharing among university students.',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiWeb,
              href: 'https://www.sehir.edu.tr/tr/sehirde-yasam/mentorluk-ofisi',
              color: 'black'
            }
          ]
        },
        {
          src: '/img/workExperience/sehir.png',
          alt: 'engineering club',
          name: 'Board Member | Istanbul Sehir University Engineering Club',
          date: '09/2017 - 01/2019',
          summary: 'As a student club, we were preparing various events such as hands-on coding events, conferences about cyber security, big data, new web development frameworks etc. Besides, we were working on various projects with members and we compete in various competitions.',
          dialog: false,
          details: false,
          links: [
            {
              icon: mdiTwitter,
              href: 'https://twitter.com/SehirMuhKulubu',
              color: '#1DA1F2'
            }
          ]
        },
      ]
    }
  },
  computed: {
    textCenter() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return false
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
    },
  }
}
</script>

<style>

</style>